import { CountryDto } from '../CountryDto';

export interface ClientAgentJurisdictionDto {
  ClientAgentJurisdictionId: Guid;
  ClientAgentId: number;
  Country: CountryDto
  InJurisdiction: boolean;    
}

export interface UpdateClientAgentJurisdictionDto {
  ClientId: Guid;
  AgentId: Guid;
  CountryCode: string;
  InJurisdiction: boolean;
  JurisdictionFree: boolean;
}

export enum JurisdictionType {
  In = "In",
  Out = "Out",
  Unset = "Unset"
}